import defaultImg from "./defaultImg"

const index = {
    install(Vue){
        Vue.component('defaultImg',defaultImg)
    }
};

export default index;
